<ng-container *ngIf="isAcmic; else maButton">
  <mapfre-button
  [ngClass]="{'custom_loader':loader}"
  [disabledValue]="!loader" 
    (click)="changePolicyEmail()"
    additionalClasses="basic primary mt-4 mb-4 h40 margin-bottom"
  >
    {{ "CHANGE_POLICY_EMAIL" | translate }}
    
  </mapfre-button>  
</ng-container>
<ng-template #maButton>
  <mapfre-button
  [ngClass]="{'custom_loader':loader}"
  [disabledValue]="!loader" 
    (click)="changePolicyEmail()"
    additionalClasses="large-btn mt-4 mb-4 h56 margin-bottom {{useAddnlClasses}}" 
  >
    {{ "CHANGE_POLICY_EMAIL" | translate }}
    
  </mapfre-button>
  
</ng-template>
